import { z } from 'zod'

export const incomeProtectionSchema = z.object({
  has_income_protection: z.boolean(),

  employment_status: z.enum([
    'permanently_employed',
    'civil_servant',
    'student',
    'apprentice',
    'self_employed',
    'retired',
    'other',
  ]),

  income: z.enum(['less_than_30k', '30k_to_50k', '50k_to_74k', 'more_than_74k']),

  illness: z.enum(['no', 'yes', 'dont_want_to_specify']),
})
